// @file Network requests related to ai talk from surface

import environment from '@@/bits/environment'
import { asciiSafeStringify } from '@@/bits/json_stringify'
import FetchableObject from '@@/surface/api/fetchable_object'
import type { AiTalkLanguageResponse, AiTalkResponse } from '@@/types'
import type { FetchOptions } from '@padlet/fetch'
import { HTTPMethod } from '@padlet/fetch'

class AiTalkApi extends FetchableObject {
  public static get baseUrl(): string {
    return environment === 'production' ? 'https://morpheus.padlet.com' : 'https://morpheus.padlet.dev'
  }

  public static async generateAudio(
    text: string,
    languageCode: string,
    voiceName: string,
    fetchOptions: FetchOptions = {},
  ): Promise<AiTalkResponse> {
    const authorization = fetchOptions.authorization?.join(' ') ?? ''
    const response = await fetch(`${this.baseUrl}/api/v1/google/tts/create`, {
      method: HTTPMethod.post,
      headers: {
        'Content-Type': 'application/json',
        Authorization: authorization,
      },
      body: asciiSafeStringify({ text, language_code: languageCode, voice_name: voiceName }),
      ...fetchOptions,
    })
    return await response.json()
  }

  public static async getLanguage(text: string, fetchOptions: FetchOptions = {}): Promise<AiTalkLanguageResponse> {
    const authorization = fetchOptions.authorization?.join(' ') ?? ''
    const response = await fetch(`${this.baseUrl}/api/v1/language/detect`, {
      method: HTTPMethod.post,
      headers: {
        'Content-Type': 'application/json',
        Authorization: authorization,
      },
      body: asciiSafeStringify({ text }),
      ...fetchOptions,
    })
    return await response.json()
  }
}

export { AiTalkApi }
